import React from "react";

export const HEXCheckIcon = () => {
  return (
    <svg
      width="14"
      height="11"
      viewBox="0 0 14 11"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="c-hex-select-button-check"
    >
      <path
        d="M2.12388 3.46672L7.31067 8.65351L5.18679 10.7774L0 5.5906L2.12388 3.46672Z"
        fill="white"
      />
      <path
        d="M13.8774 2.08776L5.18679 10.7774L3.32217 8.91262L12.0122 0.222595L13.8774 2.08776Z"
        fill="white"
      />
    </svg>
  );
};
